import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '@app/shared/base/components/base-component';
import { DialogHeaderComponent } from '../../../components/dialog/dialog-header/dialog-header.component';
import { DialogFooterComponent } from '../../../components/dialog/dialog-footer/dialog-footer.component';
import { ButtonsCancelComponent } from '../../../components/buttons/cancel/buttons-cancel.component';
import { ButtonsSubmitComponent } from '../../../components/buttons/submit/buttons-submit.component';

@Component({
  selector: 'hypecast-master-admin-form-deactivateable-dialog',
  templateUrl: './form-deactivateable-dialog.component.html',
  styleUrls: ['./form-deactivateable-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogHeaderComponent, DialogFooterComponent, ButtonsCancelComponent, ButtonsSubmitComponent],
})
export class FormDeactivateableDialogComponent extends BaseComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<FormDeactivateableDialogComponent>>(MatDialogRef);
}
